import { Form, Select, type SelectProps } from "antd";
import React, { useMemo } from "react";
import { type Rule } from "antd/es/form";
import { type FilterFunc } from "rc-select/lib/Select";
import { type DefaultOptionType } from "antd/es/cascader";
import { type Turbine } from "../../generated-axios-client";
import type { IntlShape } from "@formatjs/intl";

const turbineSelectOptions = (turbineItems: Array<Turbine>) => {
  const turbineOptions = turbineItems.map((item) => ({
    key: item.id,
    value: item.id,
    label: item.serial_number,
  }));

  return turbineOptions;
};

const turbineSearchHandler: FilterFunc<DefaultOptionType> = (input, option) => {
  const search = input.toLowerCase();
  const value = option?.label?.toString().toLowerCase?.() ?? "";

  return value.includes(search);
};

type TurbineSelectFormItemProps = {
  intl: IntlShape;
  turbineItems: Array<Turbine>;
  rules?: Rule[];
  placeholder?: string | boolean;
  selectProps?: SelectProps<string>;
};

export const TurbineSelectorFormItem = (props: TurbineSelectFormItemProps) => {
  const { intl, turbineItems, rules = [], placeholder = false, selectProps } = props;

  const options = useMemo(() => turbineSelectOptions(turbineItems), [turbineItems]);

  return (
    <Form.Item
      name="turbine"
      label={intl.formatMessage({ id: "filter_label_turbine" })}
      rules={rules}
    >
      <Select
        placeholder={placeholder}
        showSearch={true}
        options={options}
        filterOption={turbineSearchHandler}
        {...selectProps}
      />
    </Form.Item>
  );
};
